import BRModal from 'components/BRModal/BRModal';

import DomainConnectIcon from 'assets/icons/domainGlobeSmall.png';
import Timer from 'assets/bosta-images/time.png';

export const openLiveDNSModal = ({ domainLink, sllrURL, intl, openModal }) => {
  openModal(BRModal, {
    coverImage: DomainConnectIcon,
    modalClassName: 'br-live-dns-modal',
    type: 'white-footer',
    width: '372px',
    closeIcon: true,
    contentTitle: (
      <span className="display-sm">
        {intl.formatMessage(
          {
            id: 'products.sllr_store.setting_page.domains_tab.live_domain'
          },
          {
            domain: domainLink
          }
        )}
      </span>
    ),
    contentBody: (
      <span className="body">
        {intl.formatMessage(
          {
            id: 'products.sllr_store.setting_page.domains_tab.live_domain_body'
          },
          {
            TextDiv: (children) => <div>{children}</div>,
            span: (children) => <span className="body-medium">{children}</span>,
            domainLink,
            sllrURL
          }
        )}
      </span>
    ),
    primaryLabel: intl.formatMessage(
      {
        id: 'products.sllr_store.setting_page.domains_tab.view_domain'
      },
      { domainLink }
    ),
    secondaryLabel: intl.formatMessage({
      id: 'products.sllr_store.setting_page.domains_tab.check_domain'
    }),
    primaryAction: () => {
      window.open(`https://${domainLink}`, '_blank');
    },
    secondaryAction: () => {
      window.location.replace('/sllr/settings/domains');
    }
  });
};

export const openConnectedDNSModal = (intl, openModal) => {
  openModal(BRModal, {
    coverImage: Timer,
    type: 'white-footer',
    width: '372px',
    modalClassName: 'br-connect-modal',
    contentTitle: (
      <span className="display-sm">
        {intl.formatMessage({
          id: 'products.sllr_store.setting_page.domains_tab.pending_message'
        })}
      </span>
    ),
    contentBody: (
      <span className="body">
        {intl.formatMessage(
          {
            id: 'products.sllr_store.setting_page.domains_tab.connect_modal.dns_connected'
          },
          {
            TextDiv: (children) => <div>{children}</div>,
            span: (children) => <span className="body-medium">{children}</span>
          }
        )}
      </span>
    ),
    primaryLabel: intl.formatMessage({
      id: 'products.sllr_store.setting_page.domains_tab.connect_modal.dns_done_action'
    })
  });
};
